import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useTranslation } from "react-i18next";
import makeStyles from "@material-ui/core/styles/makeStyles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonBar: {
      padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    },
    cancelButton: {
      color: theme.palette.text.primary,
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    removeButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  })
);

// Display a modal to make the user acknowledge something
const DeleteBillingManagerDialog = (props: IProps) => {
  /* ---- Hooks ---- */
  const classes = useStyles();
  const { t } = useTranslation();
  const { toggle, email, positiveAction, negativeAction } = props;

  const components = {
    actions: true,
    positive: true,
    backButton: true,
  };

  return (
    <div>
      <Dialog
        open={toggle}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">{"Remove Users?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("remove_email", {
              email: email,
            })}
          </DialogContentText>
        </DialogContent>
        {components?.actions && (
          <DialogActions className={classes.buttonBar}>
            <Button
              className={classes.cancelButton}
              onClick={() => {
                negativeAction();
              }}
            >
              {t("cancel")}
            </Button>
            <Button
              className={classes.removeButton}
              onClick={() => {
                positiveAction();
              }}
            >
              {t("remove")}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
};
export default DeleteBillingManagerDialog;

export interface IProps {
  toggle: boolean;
  email: string;
  positiveAction: () => void;
  negativeAction: () => void;
  onClose: () => void;
}
